import { render, staticRenderFns } from "./CodingSchedule.vue?vue&type=template&id=2671950b&scoped=true&"
import script from "./CodingSchedule.vue?vue&type=script&lang=js&"
export * from "./CodingSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671950b",
  null
  
)

export default component.exports